<template>
  <div class='step4'>
    <div>
      <a-alert class='alert' message="特殊类型公式需先配置子公式" type="info" show-icon />
    </div>
    <br>
    <div class='subformula'>
      <a-space :size='12'>
        <a-button type='primary' @click="onAddSubformulaClick ('1')">日期时间公式转天数</a-button>
        <a-button type='primary' @click="onAddSubformulaClick ('2')">日期时间公式转小时</a-button>
        <a-button type='primary' @click="onAddSubformulaClick ('3')">时分公式转小时</a-button>
        <a-button type='primary' @click="onAddSubformulaClick ('4')">年份差计算</a-button>
      </a-space>
    </div>
    <br>
    <br>
    <div v-if='model.children && model.children.length' class='table' style='padding: 0 200px'>
      <a-table :columns='columns' :dataSource='model.children' :pagination='false' rowKey='id' size='small'></a-table>
    </div>
    <subformula-model ref='SubformulaModel' @ok='handleOk'></subformula-model>
  </div>
</template>

<script>
  import { getAction } from '@/api/manage'
  import SubformulaModel from '@views/project/setting/formula/SubformulaModel'
export default {
  name: 'Step4',
  components: { SubformulaModel },
  data() {
    return {
      model:{},
      columns: [
        {
          title: '子公式名称',
          dataIndex: 'name',
          width:200,
          ellipsis: true
        },
        {
          title: '公式内容',
          dataIndex: 'formula',
          ellipsis: true
        },
        {
          title: '类型',
          dataIndex: 'type',
          width:100,

          ellipsis: true,
          customRender:(text)=>{
            switch (text) {
              case '1':
                return '日期时间公式转天数'
              case '2':
                return '日期时间公式转小时'
              case '3':
                return '时分公式转小时'
              case '4':
                return '年份差计算'
              default:
                return ''
            }
          }
        },
        {
          title: '操作',
          width: 200,
          customRender: (text, record, index) => (
            <div><a-button size='small' type='primary' onClick={event => this.handleEdit(record,index)}>编辑</a-button>
              <a-divider type='vertical' />
              <a-button size='small' type='danger' onClick={event => this.handleDelete(record, index)}>删除</a-button></div>)
        }
      ],
      dateTypeList:{
        '1':['date','dateTime'],
        '2':['date','dateTime'],
          '3':['time'],
          '4':['number'],
      }
    }
  },
  methods: {
    view(model){
      model.children = model.children||[]
      this.model = JSON.parse(JSON.stringify(model))
    },

    /**
     * 日期时间公式转换 - 添加子公式
     * @param index
     */
    onAddSubformulaClick(index) {
      // console.log("this.model.itemList1:" + this.model.itemList1)
      const itemList = this.model.itemList1.filter(item=> this.dateTypeList[index].indexOf(item.formItem.type)>=0)
      this.model.itemList1.forEach(item=>{
        // console.log(this.dateTypeList[index],item.formItem.element.type)
        // console.log('this.dateTypeList[index].indexOf(item.formItem.element.type)>=0',this.dateTypeList[index].indexOf(item.formItem.element.type)>=0)
      })
      // console.log(itemList)
      this.$refs['SubformulaModel'].view({type: index},itemList,null)
    },
    /**
     * 编辑子公式
     */
    handleEdit(record,ri) {
      const index = record.type
      const itemList = this.model.itemList1.filter(item=> this.dateTypeList[index].indexOf(item.formItem.type)>=0)
      this.$refs['SubformulaModel'].view(record,itemList,ri)
    },
    /**
     * 删除子公式
     * @param record
     * @param index
     */
    handleDelete(record, index) {
      this.model.children.splice(index, 1)
    },
    /**
     * 回调
     */
    handleOk(record,index) {
      let error = false
      if(this.model.itemList2 ){
        this.model.itemList2.forEach((item)=>{
          if(error){
            return
          }
          if(item.name === `[${record.name}]`){
            error = true
            this.$message.warning(`公式名称不能与患者基本信息字段重复`)
          }
        })
      }
      if(error){
        return
      }
      if(index === null || index===undefined){
        this.model.children.push(record)
      }else{
        this.model.children.splice(index,1,record)
      }
    },

    /**
     * 当前步骤表单验证逻辑
     */
    validate() {
      //  可跳过,无需验证
      return true
    }

  }
}
</script>

<style scoped>
  .alert {
    width: 420px;
    margin: 0 auto;
  }
  .subformula {
    width: 100%;
    margin: 0 auto;
    text-align: center;
  }

</style>
